// App Creator Tool System - Extends ToolSystem for app creator-specific tools
// Unlike workspace tools, app creator tools focus on app creation workflow
// No filesystem, git, or editor tools needed - just app creation utilities

import { ToolSystem } from "../../../base/ToolSystem.js";

export class AppCreatorToolSystem extends ToolSystem {
  // App creator tools are minimal - focused on app creation workflow
  // Could potentially include tools for:
  // - App template suggestions
  // - Feature planning
  // - Technology recommendations
  // But for now, we start with a clean slate
}